import { memo, Suspense } from "react";

import TopBar from "@/components/top-bar";
import MyCoursesList from "@/features/my-courses/components/my-courses-list";
import MyCoursesLoading from "@/features/my-courses/components/my-course-loading";
import ContinueStudy from "@/features/home/components/continue-study";

const MyCoursesPage = () => {
  return (
    <div className="bg-secondary-background min-h-screen">
      <TopBar />
      <Suspense fallback={<MyCoursesLoading />}>
        <ContinueStudy />
        <MyCoursesList />
        <div className="h-16"></div>
      </Suspense>
    </div>
  );
};

export default memo(MyCoursesPage);
